<script setup>
/*
 * Systemkravene til et spil.
 *
 * KRAVENE ER CITATER. Kilden og datoen staar under tabellen, fordi et
 * krav uden dem er et postulat — og udgiverne aendrer tallene.
 */
import { computed } from 'vue';
import { Link } from '@inertiajs/vue3';

const RAEKKER = [
    ['os', 'Styresystem'],
    ['cpu', 'Processor'],
    ['gpu', 'Grafik'],
    ['vram', 'Grafikhukommelse'],
    ['ram', 'Hukommelse'],
    ['lager', 'Plads'],
    ['note', 'Andet'],
];

const props = defineProps({
    data: { type: Object, required: true },
});

const krav = computed(() => props.data.spil?.krav || []);
const raekker = computed(() => RAEKKER.filter(([n]) => krav.value.some((t) => t[n])));
</script>

<template>
    <p v-if="!data.spil" class="text-secondary small mb-0">
        Spillet findes ikke længere.
    </p>

    <div v-else class="table-responsive">
        <table class="table table-sm align-middle mb-2">
            <thead>
                <tr>
                    <th></th>
                    <th v-for="(t, i) in krav" :key="i">
                        {{ t.trin }}
                        <div v-if="t.maal" class="fw-normal small text-secondary">{{ t.maal }}</div>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="([noegle, etiket]) in raekker" :key="noegle">
                    <th scope="row" class="text-secondary fw-normal">{{ etiket }}</th>
                    <td v-for="(t, i) in krav" :key="i">{{ t[noegle] || '—' }}</td>
                </tr>
            </tbody>
        </table>

        <p class="small text-secondary mb-0">
            {{ data.spil.udgiver }}s egne tal<span v-if="data.spil.hentet">, efterset {{ data.spil.hentet }}</span>.
            <a v-if="data.spil.kilde" :href="data.spil.kilde" target="_blank" rel="noopener nofollow">Kilde</a>.
            <Link :href="`/spil-pc/${data.spil.slug}`">Se hele siden om {{ data.spil.navn }}</Link>.
        </p>
    </div>
</template>
